export const ProductOptionModuleName = 'Product Option';
